import { render, staticRenderFns } from "./LangRateName.vue?vue&type=template&id=3107dd6b&scoped=true&"
import script from "./LangRateName.vue?vue&type=script&lang=js&"
export * from "./LangRateName.vue?vue&type=script&lang=js&"
import style0 from "./LangRateName.vue?vue&type=style&index=0&id=3107dd6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107dd6b",
  null
  
)

export default component.exports